// material-ui
import { useTheme } from '@mui/material/styles';

import { Box, Typography } from '@mui/material';
import logoDark from 'assets/images/logo-dark.svg';
import logo from 'assets/images/logo.svg';
import useIsp from '../hooks/useIsp';
import logger from '../utils/logger';

// ==============================|| LOGO SVG ||============================== //

const Logo = () => {
  const theme = useTheme();
  const { accountType, ispInfo } = useIsp();
  logger.debug('ispInfo', ispInfo);

  if (!accountType) {
    // Synergy portal
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <Box sx={{ mr: 1 }}>
          <img style={{ maxHeight: 36, maxWidth: 38 }} src={theme.palette.mode === 'dark' ? logoDark : logo} alt="synergy" />
        </Box>
        <Typography variant="h2">Synergy</Typography>
      </Box>
    );
  }
  // ISP portal
  const ispLogo = ispInfo?.logoUrl;
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center'
      }}
    >
      {ispLogo ? (
        <Box sx={{ mr: 1 }}>
          <img style={{ maxHeight: 36, maxWidth: 194, width: '100%' }} src={ispLogo} alt={ispInfo?.ispName} />
        </Box>
      ) : (
        <Box sx={{ mr: 1, maxWidth: 194 }}>
          <Typography variant="h2">{ispInfo?.ispName}</Typography>
        </Box>
      )}
    </Box>
  );
};

export default Logo;
